export default __webpack_public_path__ + "static/media/icon-sms-code-error.d49cd8d3.svg";